export default __webpack_public_path__ + "static/powerful-start-a4d753312ee861716a100f9f7c5d8238.svg";